import { useEffect, useState } from "react";

import PrivatePolicyContainer from "./PrivatePolicyContainer";

function PrivacyPolicy(props) {
    const [policies, setPolicies] = useState();

    useEffect(() => {
        // requester.getAllPrivacyPolicies((result) => {
        //     setPolicies(result.data);
        // })
    }, []);

    return (
        <PrivatePolicyContainer title={"PRIVACY POLICY"} policies={policies}/>        
    );
}

export default PrivacyPolicy;